class Table {
    constructor(tableEl) {
        this.tableEl = tableEl;
        this.rows = Array.from(tableEl.querySelectorAll('tr'));
        this.setupResponsiveMarkup();
    }

    isHeaderCell(cell) {
        return cell.textContent === '' || cell.querySelector('strong');
    }

    setupResponsiveMarkup() {
        // Replace table with responsive setup that overlays identical tables for horizontal scroll on mobile
        this.tableEl.insertAdjacentHTML(
            'beforeBegin',
            `
                <div class="table-outer-wrap">
                    <div class="table-wrap">
                        <table>${this.tableEl.innerHTML}</table>
                    </div>
                    <div class="overlay-sticky-col">
                        <table>${this.tableEl.innerHTML}</table>
                    </div>
                </div>
            `
        );
        this.tableEl.remove();
    }
}

export default (() => {
    const tables = Array.from(document.querySelectorAll('.insurer-key-features table'));

    tables.forEach((table) => {
        new Table(table);
    });
})();
